import { queryClient } from '@/api/main/instance'
import { useApiPut } from '@/api/main/query'
import { UpdateFarmModel } from '@/entities/farm'
import { FarmWidget, FarmWidgetSkeleton } from '@/features/farm/ui/FarmWidget'
import { useDebounce, useToast } from '@/shared/hooks'
import { id } from 'date-fns/locale'
import { useState } from 'react'
import { farmsAPI } from '../../api'
import { DialogFarmActions } from '../../dialogs'
import { useFarmList } from '../../hooks'
import { BasePagination, BasePaginationSkeleton } from 'syncra-storybook/shared/components'
import { DEFAULT_TAKE } from '@/shared/constants/constants'
import { RequisitFarmProfile } from 'syncra-api-client'

export const Farms = () => {
  const [skip, setSkip] = useState(0)
  const [modalFarmActionsVisible, setModalFarmActionsVisible] = useState(false)
  const [selectedFarm, setSelectedFarm] = useState< RequisitFarmProfile | undefined>(undefined)
  const take = DEFAULT_TAKE
  const debouncedSkip = useDebounce(skip, 500)
  const { addToast } = useToast()

  const { farmsData, totalCount, isLoading, error } = useFarmList({
    skip: debouncedSkip,
    take: take,
  })

  const { mutate: updateFarm } = useApiPut< RequisitFarmProfile, UpdateFarmModel>(farmsAPI.updateFarm, {
    onSuccess: () => {
      addToast('Успех!', 'Ферма обновлена', 'success')
      queryClient.invalidateQueries({ queryKey: ['farm', id] })
      setModalFarmActionsVisible(false)
    },
    onError: (error) => {
      addToast('Ошибка!', error.message, 'error')
    },
  })

  const handleFarmSubmit = (data: UpdateFarmModel) => {
    updateFarm(data)
  }

  const handleOpenModal = (farm: RequisitFarmProfile) => {
    setSelectedFarm(farm)
    setModalFarmActionsVisible(true)
  }

  return (
    <div className="flex flex-col justify-between items-stretch w-full">
      <div className="grid gap-6 grid-cols-[repeat(auto-fill,minmax(280px,auto))] justify-start">
        {error ? (
          <p>Ошибка загрузки данных.</p>
        ) : isLoading ? (
          Array.from({ length: 4 }).map((_, index) => <FarmWidgetSkeleton key={index} />)
        ) : !farmsData || farmsData.length === 0 ? (
          <p>Ферм нет.</p>
        ) : (
          farmsData.map((farm) => {
            return <FarmWidget data={farm} key={farm.farm?.id} openModal={() => handleOpenModal(farm.farm!)} />
          })
        )}
      </div>

      {isLoading ? (
        <BasePaginationSkeleton />
      ) : (
        <div className="self-center pt-10">
          <BasePagination
            skip={skip}
            take={take}
            totalItems={totalCount}
            onPageChange={(newSkip) => setSkip(newSkip)}
          />
        </div>
      )}

      {/* Dialogs */}
      <DialogFarmActions<'update'>
        type="update"
        modalVisible={modalFarmActionsVisible}
        setModalVisible={setModalFarmActionsVisible}
        onSubmit={handleFarmSubmit}
        farmData={selectedFarm}
      />
    </div>
  )
}